import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const TextEditor = () => {
  const backUrl = process.env.REACT_APP_BACK_URL;
  const [files, setFiles] = useState({ one: null, two: null, three: null });
  const [links, setLinks] = useState({ one: "", two: "", three: "" });
  const [previews, setPreviews] = useState({ one: "", two: "", three: "" }); // for image previews
  const [uploadedBanners, setUploadedBanners] = useState([]); // db se aane wale banners

  const navigate = useNavigate();

    // --- GET NEWS API call ---
    useEffect(() => {
      const fetchNews = async () => {
        try {
          const res = await axios.get(`${backUrl}/admin/allnews`);
          console.log(res.data, "all news");
          setUploadedBanners(res.data[0] || []);
        } catch (error) {
          console.error("Error fetching news:", error);
        }
      };
      fetchNews();
    }, [backUrl]);

  const handleFileChange = (event, bannerType) => {
    const file = event.target.files[0];
    if (file) {
      setFiles((prev) => ({ ...prev, [bannerType]: file }));
      setPreviews((prev) => ({ ...prev, [bannerType]: URL.createObjectURL(file) })); // preview generate
    }
  };

 

  const handleLinkChange = (event, bannerType) => {
    const link = event.target.value;
    setLinks((prev) => ({ ...prev, [bannerType]: link }));
  };

  const submitBanner = async (bannerType) => {
    const selectedFile = files[bannerType];
    const link = links[bannerType] || ""; // default empty string
    if (!selectedFile) {
      alert("Please select a file before submitting.");
      return;
    }

    const formData = new FormData();
    formData.append("selectedFile", selectedFile);
    formData.append("banner", bannerType);
    formData.append("link", link);

    try {
      const res = await axios.post(`${backUrl}/admin/addnews`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert(res.data);
      window.location.reload();
    } catch (error) {
      console.error("Upload failed:", error);
      alert("An error occurred while uploading.");
    }
  };

  return (
    <div className="grid mt-10 place-items-center w-full px-4">
      <div className="w-full max-w-md space-y-8">
        <h2 className="text-xl font-semibold text-blue-900 mb-4">Upload Banners</h2>

        {/* Banner One */}
        <div>
          <p className="mb-2 font-medium">
            Upper Banner - Size <span className="text-red-500">(250x135)</span>
          </p>

          <img
                      src={`${backUrl}${uploadedBanners.selectedFile}`} // path backend ke hisaab se adjust karna hoga
                      alt="Uploaded Banner"
                      className="mt-2 border rounded"
                      style={{ width: "250px", height: "135px", objectFit: "cover" }}
                    />

          {/* Preview */}
          {previews.one && (
            <img
              src={previews.one}
              alt="Preview"
              className="mb-2 border rounded"
              style={{ width: "250px", height: "135px", objectFit: "cover" }}
            />
          )}

          <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, "one")} />
          <input
            type="text"
            placeholder="Enter link for Upper Banner"
            className="mt-2 p-1 border border-gray-300 rounded w-full"
            value={links.one}
            onChange={(e) => handleLinkChange(e, "one")}
          />
          <button
            onClick={() => submitBanner("one")}
            className="mt-2 bg-blue-700 hover:bg-blue-800 text-white py-1 px-3 rounded"
          >
            Upload Banner One
          </button>
        </div>

        {/* Banner Two */}
        <div>
          <p className="mb-2 font-medium">
            Bottom Banner Two - Size <span className="text-red-500">(250x135)</span>
          </p>

          <img
                      src={`${backUrl}${uploadedBanners?.selectedFiletwo}`} // path backend ke hisaab se adjust karna hoga
                      alt="Uploaded Banner"
                      className="mt-2 border rounded"
                      style={{ width: "250px", height: "135px", objectFit: "cover" }}
                    />

          {/* Preview */}
          {previews.two && (
            <img
              src={previews.two}
              alt="Preview"
              className="mb-2 border rounded"
              style={{ width: "250px", height: "135px", objectFit: "cover" }}
            />
          )}

          <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, "two")} />
          <input
            type="text"
            placeholder="Enter link for Bottom Banner"
            className="mt-2 p-1 border border-gray-300 rounded w-full"
            value={links.two}
            onChange={(e) => handleLinkChange(e, "two")}
          />
          <button
            onClick={() => submitBanner("two")}
            className="mt-2 bg-blue-700 hover:bg-blue-800 text-white py-1 px-3 rounded"
          >
            Upload Banner Two
          </button>
        </div>

        {/* Banner Three */}
        <div>
          <p className="mb-2 font-medium">
            Live Match Banner - Size <span className="text-red-500">(372x135)</span>
          </p>

          <img
                      src={`${backUrl}${uploadedBanners?.selectedFilethree}`} // path backend ke hisaab se adjust karna hoga
                      alt="Uploaded Banner"
                      className="mt-2 border rounded"
                      style={{ width: "250px", height: "135px", objectFit: "cover" }}
                    />

          {/* Preview */}
          {previews.three && (
            <img
              src={previews.three}
              alt="Preview"
              className="mb-2 border rounded"
              style={{ width: "372px", height: "135px", objectFit: "cover" }}
            />
          )}

          <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, "three")} />
          <input
            type="text"
            placeholder="Enter link for Live Match Banner"
            className="mt-2 p-1 border border-gray-300 rounded w-full"
            value={links.three}
            onChange={(e) => handleLinkChange(e, "three")}
          />
          <button
            onClick={() => submitBanner("three")}
            className="mt-2 bg-blue-700 hover:bg-blue-800 text-white py-1 px-3 rounded"
          >
            Upload Banner Three
          </button>
        </div>
      </div>
    </div>
  );
};

export default TextEditor;
